var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFilled = function SvgDownloadFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9315",
    stroke: "#FF9315",
    d: "M18.498 10.945a.3.3 0 0 0-.212-.513H14.72V4H8.29v6.432H4.724a.3.3 0 0 0-.212.513l6.78 6.78a.3.3 0 0 0 .425 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9315",
    strokeWidth: 1.5,
    d: "M4.153 21h14.704"
  })));
};
export default SvgDownloadFilled;